import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0 28h14c7.72 0 14-6.28 14-14S21.72 0 14 0 0 6.28 0 14zM14 2.333c6.433 0 11.667 5.234 11.667 11.667S20.433 25.667 14 25.667H2.333V14C2.333 7.567 7.567 2.333 14 2.333m-1.167 3.5h2.334V17.5h-2.334zm0 14h2.334v2.334h-2.334z"
    }, null, -1)
  ]))]))
}
export default { render: render }